/* eslint-disable */
import React, { Component } from 'react';
import VirtualizedSelect from 'react-virtualized-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import debounce from 'debounce-promise';
import styles from './styles.scss';

const axios = require('axios');

const fetchOrgsFromParticipants = (input, region) => {
  if (input && input.length > 2) {
    return new Promise(resolve => {
      axios
        .get('/api/firm/filter/', {
          params: {
            name: input,
          },
        })
        .then(function (response) {
          if (response.data && response.data.length > 0) {
            resolve({
              options: response.data.map(x => {
                const regionData = region.find(el => +el.id === +x.regionId);
                return {
                  label: x.name,
                  inn: x.inn,
                  kpp: x.kpp,
                  ogrn: x.ogrn,
                  optionId: x.id,
                  id: x.id,
                  firmTypeId: x.typeId,
                  regionName: regionData ? regionData.name : '',
                  regionCode: regionData ? regionData.code : '',
                };
              }),
            });
          } else {
            resolve({
              options: [],
            });
          }
        });
    });
  } else {
    return Promise.resolve({
      options: [],
    });
  }
};

const fetchOrgsFromBasis = ({ input, region, noIP, querySize }) => {
  if (input && input.length > 2) {
    return new Promise(resolve => {
      axios
        .post('/api/firm/basis/suggest/', {
          options: {
            q: input,
            noIP: noIP,
            size: querySize,
          },
        })
        .then(function (response) {
          if (response.data && response.data.length > 0) {
            resolve({
              options: response.data.map(x => {
                const regionData = region.find(el => +el.code === +x.Region);
                return {
                  label: x.ShortName || x.FullName || '-',
                  inn: x.Inn,
                  kpp: x.Kpp,
                  ogrn: x.Ogrn,
                  optionId: x.Ogrn,
                  firmTypeId: x.typeId,
                  regionName: regionData ? regionData.name : '',
                  regionCode: regionData ? x.Region : '',
                };
              }),
            });
          } else {
            resolve({
              options: [],
            });
          }
        });
    });
  } else {
    return Promise.resolve({
      options: [],
    });
  }
};

const selectedOrgRenderer = option => {
  return (
    <span>
      <label>
        {_.truncate(option.label, {
          length: 65,
          omission: '...',
        })}
      </label>
      <p>
        <span>ИНН: </span>
        {option.inn}
      </p>
    </span>
  );
};

const ogrnRenderer = ogrn => {
  if (!ogrn) return '';
  if (ogrn.toString().length > 14) return `ОГРНИП: ${ogrn}`;
  return `ОГРН: ${ogrn}`;
};

const CustomOptionRenderer = ({ focusedOption, focusOption, key, option, selectValue, style, valueArray }) => {
  const classNames = [styles.option];
  if (option === focusedOption) {
    classNames.push(styles['optionFocused']);
  }
  if (valueArray.indexOf(option) >= 0) {
    classNames.push(styles['option-selected']);
  }

  return (
    <div
      className={classNames.join(' ')}
      key={key}
      onClick={() => selectValue(option)}
      onMouseOver={() => focusOption(option)}
      style={style}
    >
      <label className={styles['option-name']}>{option.label}</label>
      <p className={styles['reqRow']}>
        <span className={styles['optionReq']}>{option.inn ? `ИНН: ${option.inn}` : ''}</span>
        <span className={styles['optionReq']}>{option.kpp ? `КПП: ${option.kpp}` : ''}</span>
        <span className={styles['optionReq']}>{ogrnRenderer(option.ogrn)}</span>
        <span className={styles['optionReq']}>{option.regionName ? `Регион: ${option.regionName}` : ''}</span>
      </p>
    </div>
  );
};

const GetOptionHeight = option => {
  const { option: opt } = option;
  const symbCount = 75;
  const firstRow = 17;
  const paddings = 30;
  const secondRow = 14;
  return (opt.label.length / symbCount + 1) * firstRow + paddings + secondRow;
};

class SelectBasis extends Component {
  render() {
    const { onSelect, placeholder, searchParticipants, filterOption, region, noIP, querySize = 20 } = this.props;
    let { selectProperty } = this.props;
    selectProperty = selectProperty || {};
    const apiSearch = debounce(input => {
      return searchParticipants
        ? fetchOrgsFromParticipants(input, region)
        : fetchOrgsFromBasis({ input, region, noIP, querySize });
    }, 500);
    return (
      <div className={styles.container_select}>
        <VirtualizedSelect
          {...selectProperty}
          async
          valueKey="optionId"
          loadOptions={apiSearch}
          onChange={selectValue => onSelect(selectValue)}
          styles={{ zIndex: 2 }}
          autoload={false}
          placeholder={placeholder}
          loadingPlaceholder="Загрузка..."
          searchPromptText="Введите поисковый запрос"
          filterOption={filterOption ? filterOption : () => true}
          optionRenderer={CustomOptionRenderer}
          optionHeight={GetOptionHeight}
          valueRenderer={selectedOrgRenderer}
          noResultsText="Не найдено"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({ region: state.dictionary.region });

export default connect(mapStateToProps)(SelectBasis);
